const baseUserUrl = "User"


  const endpoints = {
   getUserAdvertList:`${baseUserUrl}/GetUserAdvertList`,
   getUserAdvertStatusInfo:`${baseUserUrl}/GetUserAdvertStatusInfo`,

  }

  export default endpoints

